import { APP_STORE_URL, PLAY_STORE_URL } from "@groupeo/shared";
import { useTranslation } from "react-i18next";
import { BreadcrumbJsonLd } from "@/src/common/components/breadcrumb-jsonld";
import { JsonLd } from "@/src/common/components/json-ld";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { env } from "@/src/common/constants/env";
import { AudienceSection } from "../components/sections/audience-section";
import { CtaSection } from "../components/sections/cta-section";
import { FeaturesSection } from "../components/sections/features-section";
import { ValueSection } from "../components/sections/value-section";
import { SiteShell } from "../components/site-shell";
import { MARKETING_ROUTES } from "../constants/marketing-routes";

const FeaturesPage: React.FC = () => {
	const { t } = useTranslation("marketing");
	const pageUrl = `${env.SITE_URL}${MARKETING_ROUTES.FEATURES}`;

	return (
		<>
			<PageHelmet title={t("features_page_title")} description={t("features_page_description")} />
			<BreadcrumbJsonLd
				items={[
					{ name: t("breadcrumb_home"), url: env.SITE_URL },
					{ name: t("nav_features"), url: pageUrl },
				]}
			/>
			<JsonLd
				data={{
					"@context": "https://schema.org",
					"@type": "SoftwareApplication",
					name: env.APP_NAME,
					operatingSystem: "iOS, Android",
					applicationCategory: "SocialNetworkingApplication",
					offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
					downloadUrl: `${env.SITE_URL}${MARKETING_ROUTES.DOWNLOAD}`,
					installUrl: [APP_STORE_URL, PLAY_STORE_URL],
					featureList: [
						"Private invite-only groups",
						"Photo and video sharing",
						"Stories",
						"Reactions and comments",
						"Private messaging",
						"PIN and biometric protection",
						"Push notifications",
					],
				}}
			/>
			<SiteShell>
				<main className="overflow-hidden">
					<div className="mx-auto max-w-7xl px-6 pb-24 pt-8 sm:px-8 lg:px-12">
						<header className="max-w-3xl py-12">
							<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("nav_features")}</p>
							<h1 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-6xl">{t("features_page_title")}</h1>
							<p className="mt-5 text-lg leading-8 text-white/70">{t("features_page_intro")}</p>
						</header>
						<ValueSection />
						<FeaturesSection />
						<AudienceSection />
						<CtaSection />
					</div>
				</main>
			</SiteShell>
		</>
	);
};

export default FeaturesPage;
